<template>
  <div class="blik-invoice-page-wrap" :class="{ 'options-card-wrapper--no-padding': noPadding }">
    <div class="blik-invoice-page__locale" ref="localeMenu" @click.stop="toggleLocaleMenu">
      <svg
        class="blik-invoice-page__locale-icon"
        width="17"
        height="28"
        viewBox="0 0 17 26"
        fill="none"
        aria-hidden="true">
        <path
          d="M8.94 19.68C7.84667 19.68 6.82 19.4733 5.86 19.06C4.91333 18.66 4.07333 18.1 3.34 17.38C2.62 16.6467 2.05333 15.8 1.64 14.84C1.22667 13.88 1.02 12.8533 1.02 11.76C1.02 10.6667 1.22667 9.64 1.64 8.68C2.05333 7.72 2.62 6.88 3.34 6.16C4.07333 5.42667 4.91333 4.86 5.86 4.46C6.82 4.04667 7.84667 3.84 8.94 3.84C10.0333 3.84 11.06 4.04667 12.02 4.46C12.98 4.86 13.82 5.42667 14.54 6.16C15.2733 6.88 15.84 7.72 16.24 8.68C16.6533 9.64 16.86 10.6667 16.86 11.76C16.86 12.8533 16.6533 13.88 16.24 14.84C15.84 15.8 15.2733 16.6467 14.54 17.38C13.82 18.1 12.98 18.66 12.02 19.06C11.06 19.4733 10.0333 19.68 8.94 19.68ZM8.94 18.3C9.84667 18.3 10.6933 18.1333 11.48 17.8C12.2667 17.4533 12.96 16.98 13.56 16.38C14.16 15.78 14.6267 15.0867 14.96 14.3C15.3067 13.5133 15.48 12.6667 15.48 11.76C15.48 10.8533 15.3067 10.0067 14.96 9.22C14.6267 8.43333 14.16 7.74 13.56 7.14C12.96 6.54 12.2667 6.07333 11.48 5.74C10.6933 5.39333 9.84667 5.22 8.94 5.22C8.03333 5.22 7.18667 5.39333 6.4 5.74C5.61333 6.07333 4.92 6.54 4.32 7.14C3.72 7.74 3.24667 8.43333 2.9 9.22C2.56667 10.0067 2.4 10.8533 2.4 11.76C2.4 12.6667 2.56667 13.5133 2.9 14.3C3.24667 15.0867 3.72 15.78 4.32 16.38C4.92 16.98 5.61333 17.4533 6.4 17.8C7.18667 18.1333 8.03333 18.3 8.94 18.3ZM8.94 17.34C8.16667 17.34 7.44 17.2 6.76 16.92C6.09333 16.6267 5.5 16.2267 4.98 15.72C4.47333 15.2 4.07333 14.6067 3.78 13.94C3.5 13.26 3.36 12.5333 3.36 11.76C3.36 10.9867 3.5 10.2667 3.78 9.6C4.07333 8.92 4.47333 8.32667 4.98 7.82C5.5 7.3 6.09333 6.9 6.76 6.62C7.44 6.32667 8.16667 6.18 8.94 6.18C9.71333 6.18 10.44 6.32667 11.12 6.62C11.8 6.9 12.3933 7.3 12.9 7.82C13.42 8.32667 13.82 8.92 14.1 9.6C14.3933 10.2667 14.54 10.9867 14.54 11.76C14.54 12.5333 14.3933 13.26 14.1 13.94C13.82 14.6067 13.42 15.2 12.9 15.72C12.3933 16.2267 11.8 16.6267 11.12 16.92C10.44 17.2 9.71333 17.34 8.94 17.34Z"
          fill="currentColor" />
      </svg>

      <span>{{ currentLocale.toUpperCase() }}</span>
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
        <path
          d="M3 4.5L6 7.5L9 4.5"
          stroke="currentColor"
          stroke-width="1.4"
          stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
      <div v-if="localeMenuOpen" class="blik-invoice-page__locale-dropdown">
        <div
          v-for="locale in locales"
          :key="locale"
          class="blik-invoice-page__locale-item"
          :class="{ active: locale === currentLocale }"
          @click.stop="selectLocale(locale)">
          {{ locale.toUpperCase() }}
        </div>
      </div>
    </div>

    <div class="blik-invoice-page">
      <div class="blik-invoice-page__header">
        <div class="blik-invoice-page__logo">
          <img :src="logo" alt="BLIK" />
        </div>
      </div>

      <div v-if="referenceId" class="blik-invoice-page__reference">
        <div class="blik-invoice-page__reference-label">{{ $t('field__reference_id') }}</div>
        <div class="blik-invoice-page__reference-value">{{ referenceId }}</div>
      </div>

      <div class="blik-invoice-page__amount">{{ amount }} {{ currency }}</div>
      <div class="blik-invoice-page__method">BLIK</div>

      <slot :logo="logo" :color-scheme="colorScheme" />
    </div>
  </div>
</template>

<script>
import { messages } from '../translations/index';
import invoicePageLocales from '@/mixins/invoicePageLocales';
import BlikLogoDarkTheme from '../assets/blik-logo-dark-theme.svg';
import BlikLogoLightTheme from '../assets/blik-logo-light-theme.svg';
import BrowserColorSchemeService from '@/services/BrowserColorSchemeService';
import { blikColorSchemeBackgrounds } from '../const/colorScheme';

export default {
  name: 'BlikInvoicePageLayout',
  mixins: [invoicePageLocales(messages)],

  props: {
    noPadding: {
      type: Boolean,
      default: false,
    },
    referenceId: {
      type: [String, Number],
      default: null,
    },
    amount: {
      type: [String, Number],
      default: '',
    },
    currency: {
      type: String,
      default: '',
    },
    defaultLocale: {
      type: String,
      default: null,
    },
  },

  created() {
    this.colorSchemeService = new BrowserColorSchemeService({
      backgrounds: blikColorSchemeBackgrounds,
      onChange: scheme => {
        this.colorScheme = scheme;
      },
    });
    this.colorSchemeService.start();
    this.initDefaultLocales();
    this.applyInitialLocale();
  },

  mounted() {
    document.addEventListener('click', this.closeLocaleMenu);
  },

  beforeDestroy() {
    document.removeEventListener('click', this.closeLocaleMenu);

    if (this.colorSchemeService) {
      this.colorSchemeService.stop();
    }
  },

  data() {
    return {
      localeMenuOpen: false,
      colorScheme: 'light',
    };
  },

  computed: {
    currentLocale() {
      return this.$i18n.locale;
    },

    logo() {
      return this.colorScheme === 'dark' ? BlikLogoDarkTheme : BlikLogoLightTheme;
    },
  },

  methods: {
    toggleLocaleMenu() {
      this.localeMenuOpen = !this.localeMenuOpen;
    },

    closeLocaleMenu(event) {
      if (this.$refs.localeMenu && !this.$refs.localeMenu.contains(event.target)) {
        this.localeMenuOpen = false;
      }
    },

    selectLocale(locale) {
      this.localeMenuOpen = false;
      this.$bus.$emit('changeLocale', locale);
    },
  },
};
</script>
